import script from "./SelectRooms.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectRooms.vue?vue&type=script&setup=true&lang=js"

import "./SelectRooms.vue?vue&type=style&index=0&id=2b85b2d3&scoped=true&lang=css"

import exportComponent from "/Users/zane/Dev/ionic-spirit/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b85b2d3"]])

export default __exports__